// @mui
import { alpha, styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

const CustomSmallSelect = styled((props) => <TextField  select SelectProps={{ native: true }} {...props} />)(
  ({ theme }) => ({
    '& fieldset': {
    },
    '& select': {
    },
    '& .MuiOutlinedInput-root': {
    },
  })
);

export default CustomSmallSelect;
